import React from "react";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      style={{
        background: "transparent",
        border: "1px solid var(--text-color)",
        padding: "6px 12px",
        borderRadius: "20px",
        color: "var(--text-color)",
        cursor: "pointer"
      }}
    >
      {theme === "dark" ? "☀ Light" : "🌙 Dark"}
    </button>
  );
};

export default ThemeToggle;
